module.exports = __webpack_public_path__ + "img/pause.3cd96fb2.svg";